"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceCardApplicationPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_markdown_1 = require("react-markdown/lib/react-markdown");
var terms_1 = require("../../api/calls/strapi/terms");
var main_1 = require("../../reducers/slices/main");
var react_redux_1 = require("react-redux");
var add_card_screen_png_1 = __importDefault(require("../../assets/choice_card/add_card_screen.png"));
var react_router_dom_1 = require("react-router-dom");
var loyalty_signup_1 = require("../../api/calls/loyalty/loyalty_signup");
var sign_up_1 = require("../../api/calls/user/sign_up");
var loyalty_signup_guest_1 = require("../../api/calls/loyalty/loyalty_signup_guest");
var nearest_branches_1 = require("../../api/calls/client/nearest_branches");
var get_member_1 = require("../../api/calls/loyalty/get_member");
var control_colors_1 = require("../../constants/control_colors");
var get_card_status_1 = require("../../api/calls/loyalty/get_card_status");
var ChoiceCardApplicationPage = function (props) {
    var _a = props;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _b = (0, react_1.useState)([]), termsData = _b[0], setTermsData = _b[1];
    var _c = (0, react_1.useState)(""), agreesMessage = _c[0], setAgreesMessage = _c[1];
    var _d = (0, react_1.useState)(false), agreesToTerms = _d[0], setAgreesToTerms = _d[1];
    var _e = (0, react_1.useState)(false), iHaveReadTerms = _e[0], setIHaveReadTerms = _e[1];
    var _f = (0, react_1.useState)("No"), loyaltyMemberStatus = _f[0], setLoyaltyMemberStatus = _f[1];
    var _g = (0, react_1.useState)(null), userGender = _g[0], setUserGender = _g[1];
    var _h = (0, react_1.useState)(null), selectedBrach = _h[0], setSelectedBrach = _h[1];
    var _j = (0, react_1.useState)([]), branchesList = _j[0], setBranchesList = _j[1];
    var _k = (0, react_1.useState)([]), communicationMethod = _k[0], setCommunicationMethod = _k[1];
    var _l = (0, react_1.useState)(), loyaltyCardNumber = _l[0], setLoyaltyCardNumber = _l[1];
    var _m = (0, react_1.useState)(""), loyaltyCardNumberErrorText = _m[0], setLoyaltyCardNumberErrorText = _m[1];
    var _o = (0, react_1.useState)(), phoneNumber = _o[0], setPhoneNumber = _o[1];
    var _p = (0, react_1.useState)(""), phoneNumberErrorText = _p[0], setPhoneNumberErrorText = _p[1];
    var _q = (0, react_1.useState)(), email = _q[0], setEmail = _q[1];
    var _r = (0, react_1.useState)(""), emailErrorText = _r[0], setEmailErrorText = _r[1];
    var _s = (0, react_1.useState)(), firstName = _s[0], setFirstName = _s[1];
    var _t = (0, react_1.useState)(""), firstNameErrorText = _t[0], setFirstNameErrorText = _t[1];
    var _u = (0, react_1.useState)(), lastName = _u[0], setLastName = _u[1];
    var _v = (0, react_1.useState)(""), lastNameErrorText = _v[0], setLastNameErrorText = _v[1];
    var _w = (0, react_1.useState)(""), dateOfBirthErrorMessage = _w[0], setDateOfBirthErrorMessage = _w[1];
    var _x = (0, react_1.useState)(""), addressErrorMessage = _x[0], setAddressErrorMessage = _x[1];
    var _y = (0, react_1.useState)(""), genderErrorText = _y[0], setGenderErrorText = _y[1];
    var _z = (0, react_1.useState)(), dateOfBirth = _z[0], setDateOfBirth = _z[1];
    var _0 = (0, react_1.useState)(false), isLoading = _0[0], setIsLoading = _0[1];
    var _1 = (0, react_1.useState)({
        label: "",
        fullAddress: "",
        coordinates: {
            lat: "",
            lng: "",
        },
    }), address = _1[0], setAddress = _1[1];
    (0, react_1.useEffect)(function () {
        (0, terms_1.user_terms)().then(function (response) {
            if (response) {
                setTermsData(response);
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Oops!",
                    messages: ["Sorry! We could not retrieve the terms and conditions at the moment! Please try again later."],
                }));
            }
        });
    }, []);
    (0, react_1.useEffect)(function () {
        if (address.fullAddress) {
            (0, nearest_branches_1.nearest_branches)({
                size: "10",
                longitude: address.coordinates.lng,
                latitude: address.coordinates.lat,
            }).then(function (response) {
                if (response.success) {
                    var qwe = response.content.map(function (b, i) {
                        var _a, _b;
                        return {
                            label: (_a = b === null || b === void 0 ? void 0 : b.branch) === null || _a === void 0 ? void 0 : _a.display_name,
                            value: (_b = b === null || b === void 0 ? void 0 : b.branch) === null || _b === void 0 ? void 0 : _b._id,
                        };
                    });
                    setBranchesList(qwe);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Could not get all branches!",
                        messages: [response.message],
                    }));
                }
            });
        }
    }, [address]);
    (0, react_1.useEffect)(function () {
        //
        if (!(user === null || user === void 0 ? void 0 : user._id)) {
            setLoyaltyMemberStatus("Yes");
        }
    }, [user]);
    var loyaltySignUp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var linkLoyalty_1, response, myAddress, _a, getCardStatus, guestUser, newUser, currentTime, createdTime, minuteInMilliseconds, timeDifference, existing_member;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!validate()) return [3 /*break*/, 13];
                    linkLoyalty_1 = false;
                    response = void 0;
                    myAddress = {
                        label: "Home",
                        full_address: address.fullAddress,
                        longitude: address.coordinates.lng,
                        latitude: address.coordinates.lat,
                        default: false,
                    };
                    setIsLoading(true);
                    if (!(user === null || user === void 0 ? void 0 : user._id)) return [3 /*break*/, 6];
                    _a = loyaltyMemberStatus;
                    switch (_a) {
                        case "Yes": return [3 /*break*/, 1];
                        case "No": return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1: return [4 /*yield*/, (0, loyalty_signup_1.loyalty_signup)({
                        card_number: loyaltyCardNumber,
                        existing_member: true,
                    })];
                case 2:
                    response = _d.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, (0, loyalty_signup_1.loyalty_signup)({
                        dob: dateOfBirth,
                        address: myAddress,
                        existing_member: false,
                        communication_method: communicationMethod,
                    })];
                case 4:
                    response = _d.sent();
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 13];
                case 6:
                    if (!loyaltyCardNumber) return [3 /*break*/, 8];
                    return [4 /*yield*/, (0, get_card_status_1.get_card_status)({
                            card_number: loyaltyCardNumber,
                        })];
                case 7:
                    getCardStatus = _d.sent();
                    if (getCardStatus.success) {
                        switch (getCardStatus.content.status) {
                            case "AWAIT":
                            case "AVAILABLE":
                                break;
                            case "LINKED":
                            case "UNAVAILABLE":
                                dispatch((0, main_1.setMessageModal)({
                                    title: "Oops!",
                                    messages: [
                                        "It looks like this card is already being used by another account. Please send an email to care@thelocalchoice.net and our trusted team will assist with your application",
                                    ],
                                }));
                                setIsLoading(false);
                                return [2 /*return*/];
                        }
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Oops!",
                            messages: [
                                "Looks like there was an error processing your request. Please send an email to care@thelocalchoice.net and our trusted team will assist with your application",
                            ],
                        }));
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    _d.label = 8;
                case 8: 
                //check if existing loyalty member
                return [4 /*yield*/, (0, get_member_1.loyalty_member)({
                        cell_number: phoneNumber,
                    }).then(function (response) {
                        if (response.success) {
                            setIsLoading(false);
                            dispatch((0, main_1.setMessageModal)({
                                title: "Oops!",
                                messages: ["Looks like you already have a loyalty account - sign in to your existing account or register to update your personal details"],
                            }));
                            return;
                        }
                        else {
                            linkLoyalty_1 = true;
                        }
                    })];
                case 9:
                    //check if existing loyalty member
                    _d.sent();
                    return [4 /*yield*/, (0, sign_up_1.sign_up)({
                            loyalty_sign_up: false,
                            name: firstName !== null && firstName !== void 0 ? firstName : "",
                            surname: lastName !== null && lastName !== void 0 ? lastName : "",
                            email: email !== null && email !== void 0 ? email : "",
                            cell_number: phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : "",
                            cell_country_code: "+27",
                            password: "_".concat(Math.random().toString(36).substr(2, 16)),
                            gender: userGender,
                            is_guest: true,
                            get_communication: communicationMethod ? true : false,
                            agrees_terms_and_conditions: agreesToTerms,
                        })];
                case 10:
                    guestUser = _d.sent();
                    newUser = false;
                    currentTime = new Date().getTime();
                    createdTime = new Date((_c = (_b = guestUser === null || guestUser === void 0 ? void 0 : guestUser.content) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.createdAt).getTime();
                    minuteInMilliseconds = 1 * 60 * 1000;
                    timeDifference = currentTime - createdTime;
                    if (timeDifference > minuteInMilliseconds) {
                        newUser = false;
                    }
                    else {
                        newUser = true;
                    }
                    existing_member = false;
                    if (loyaltyCardNumber) {
                        existing_member = true;
                    }
                    if (!linkLoyalty_1) return [3 /*break*/, 12];
                    return [4 /*yield*/, (0, loyalty_signup_guest_1.loyalty_signup_guest)({
                            card_number: loyaltyCardNumber,
                            dob: dateOfBirth,
                            address: myAddress,
                            existing_member: existing_member,
                            communication_method: communicationMethod,
                        }, guestUser)];
                case 11:
                    response = _d.sent();
                    _d.label = 12;
                case 12:
                    //If signup was successful
                    if (response === null || response === void 0 ? void 0 : response.success) {
                        setIsLoading(false);
                        dispatch((0, main_1.setMessageModal)({
                            title: "Choice Card!",
                            messages: ["Congrats! You have successfully signed up for your choice card"],
                        }));
                        setIsLoading(false);
                        navigate("/choice-card");
                    }
                    else {
                        setIsLoading(false);
                        dispatch((0, main_1.setMessageModal)({
                            title: "Oops!",
                            messages: ["Looks like you already have a loyalty account - sign in to your existing account or register to update your personal details"],
                        }));
                    }
                    _d.label = 13;
                case 13: return [2 /*return*/];
            }
        });
    }); };
    var validate = function () {
        var validator = true;
        if (user === null || user === void 0 ? void 0 : user._id) {
            switch (loyaltyMemberStatus) {
                case "Yes":
                    if (!loyaltyCardNumber) {
                        setLoyaltyCardNumberErrorText("Please enter your loyalty card number");
                        validator = false;
                    }
                    break;
                case "No":
                    if (!address.fullAddress) {
                        setAddressErrorMessage("Please enter your address");
                        validator = false;
                    }
                    if (!dateOfBirth) {
                        setDateOfBirthErrorMessage("Please enter your date of birth");
                        validator = false;
                    }
                    break;
            }
        }
        else {
            // if (!loyaltyCardNumber) {
            //   setLoyaltyCardNumberErrorText("Please enter your loyalty card number");
            //   validator = false;
            // }
            if (!address.fullAddress) {
                setAddressErrorMessage("Please enter your address");
                validator = false;
            }
            if (!firstName) {
                setFirstNameErrorText("Please enter your first name");
                validator = false;
            }
            if (!lastName) {
                setLastNameErrorText("Please enter your last name");
                validator = false;
            }
            if (!email) {
                setEmailErrorText("Please enter your email");
                validator = false;
            }
            if (!userGender) {
                setGenderErrorText("Please choose your gender");
                validator = false;
            }
            if (!phoneNumber) {
                setPhoneNumberErrorText("Please enter your phone number");
                validator = false;
            }
            if (!dateOfBirth) {
                setDateOfBirthErrorMessage("Please enter your date of birth");
                validator = false;
            }
        }
        return validator;
    };
    var _2 = (0, react_1.useState)(false), emailMethod = _2[0], setEmailMethod = _2[1];
    var _3 = (0, react_1.useState)(false), smsMethod = _3[0], setSmsMethod = _3[1];
    var _4 = (0, react_1.useState)(false), whatsAppMethod = _4[0], setWhatsAppMethod = _4[1];
    var manageComMethod = function (method, value) {
        var comMethod = communicationMethod;
        if (method) {
            switch (method) {
                case "SMS":
                    value == true ? comMethod.push("SMS") : (comMethod = comMethod.filter(function (element) { return element !== "SMS"; }));
                    break;
                case "EMAIL":
                    value == true ? comMethod.push("EMAIL") : (comMethod = comMethod.filter(function (element) { return element !== "EMAIL"; }));
                    break;
                case "WHATSAPP":
                    value == true ? comMethod.push("WHATSAPP") : (comMethod = comMethod.filter(function (element) { return element !== "WHATSAPP"; }));
                    break;
            }
            setCommunicationMethod(comMethod);
        }
    };
    return (react_1.default.createElement("div", { className: "relative" },
        react_1.default.createElement("div", { className: "flex flex-col justify-center" },
            react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null, iHaveReadTerms ? (react_1.default.createElement("div", { className: "" },
                react_1.default.createElement("div", { className: "flex flex-col " },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Apply Online", size: "3xlarge", textColor: "text-primary", center: true, bold: true })),
                react_1.default.createElement("div", { className: "flex flex-col gap-4 p-10  items-center" },
                    user._id && (react_1.default.createElement(doshx_controls_web_1.RadioButtonsControl, { title: "Are you already a loyalty member?", colors: control_colors_1.radio_colors, selectedValue: loyaltyMemberStatus, options: [
                            { label: "Yes", value: "Yes" },
                            { label: "No", value: "No" },
                        ], onChange: function (value) {
                            setLoyaltyMemberStatus(value);
                        } })),
                    loyaltyMemberStatus === "Yes" ? (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Loyalty Card Number", borderColor: "border-[#EEEEEE]", value: loyaltyCardNumber, errorTextColor: "text-red-500", errorText: loyaltyCardNumberErrorText, onChange: function (v) {
                                setLoyaltyCardNumber(v);
                            } }),
                        !user._id && (react_1.default.createElement("div", { className: "flex flex-col gap-4 w-full" },
                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "First Name", borderColor: "border-[#EEEEEE]", value: firstName, errorTextColor: "text-red-500", errorText: firstNameErrorText, onChange: function (v) {
                                    setFirstName(v);
                                } }),
                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Surname", borderColor: "border-[#EEEEEE]", value: lastName, errorTextColor: "text-red-500", errorText: lastNameErrorText, onChange: function (v) {
                                    setLastName(v);
                                } }),
                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", borderColor: "border-[#EEEEEE]", value: email, errorTextColor: "text-red-500", errorText: emailErrorText, onChange: function (v) {
                                    setEmail(v);
                                } }),
                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Phone", borderColor: "border-[#EEEEEE]", value: phoneNumber, errorTextColor: "text-red-500", errorText: phoneNumberErrorText, onChange: function (v) {
                                    setPhoneNumber(v);
                                } }),
                            react_1.default.createElement(doshx_controls_web_1.AddressSearchControl, { label: "Physical Address/ Unit Number/ Building Name", borderColor: "border-[#EEEEEE]", value: address, errorText: addressErrorMessage, errorTextColor: "text-red-500", onSelectionChange: function (v) {
                                    setAddress(v);
                                } }),
                            react_1.default.createElement(doshx_controls_web_1.DatePickerControl, { label: "Date Of Birth", borderColor: "border-[#EEEEEE]", inputFormat: "DD/MM/YYYY", errorText: dateOfBirthErrorMessage, value: dateOfBirth, onChange: function (v) {
                                    setDateOfBirth(v);
                                } }),
                            react_1.default.createElement(doshx_controls_web_1.RadioButtonsControl, { title: "Gender", errorText: genderErrorText, colors: control_colors_1.radio_colors, selectedValue: userGender, options: [
                                    { label: "MALE", value: "MALE" },
                                    { label: "FEMALE", value: "FEMALE" },
                                ], onChange: function (value) {
                                    setUserGender(value);
                                } }),
                            react_1.default.createElement(doshx_controls_web_1.DropdownControl, { options: branchesList, borderColor: "border-[#EEEEEE]", errorTextColor: "text-red-500", label: "Preferred Branch", value: selectedBrach, onChange: function (v) {
                                    setSelectedBrach(v);
                                } }),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Receive trusted health advice and the latest news and promotions", size: "medium", textColor: "text-[#8F9BB3]", center: true }),
                                react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "SMS", uncheckedColor: "text-primary", value: smsMethod, onChange: function (v) {
                                        manageComMethod("SMS", v);
                                    } }),
                                react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "EMAIL", uncheckedColor: "text-primary", value: emailMethod, onChange: function (v) {
                                        manageComMethod("EMAIL", v);
                                    } }),
                                react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "WHATSAPP", uncheckedColor: "text-primary", value: whatsAppMethod, onChange: function (v) {
                                        manageComMethod("WHATSAPP", v);
                                    } })))),
                        react_1.default.createElement("div", { className: "flex flex-col items-center" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "If you don't know your loyalty card number.", size: "medium", textColor: "text-black", center: true, bold: true }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Please send email to:", size: "medium", textColor: "text-[#8F9BB3]", center: true }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "care@thelocalchoice.net", size: "medium", textColor: "text-primary", center: true }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Our trusted team will search and add your loyalty card number.", size: "medium", textColor: "text-[#8F9BB3]", center: true })))) : (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                        react_1.default.createElement("div", { className: "flex flex-col items-center" },
                            react_1.default.createElement("img", { src: add_card_screen_png_1.default, className: "h-full py-5" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Add a free virtual card.", size: "medium", textColor: "text-black", center: true, bold: true }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "You can starrt earning immediately with your choice virtual card", size: "medium", textColor: "text-[#8F9BB3]", center: true }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Learn more", size: "medium", textColor: "text-primary", center: true }),
                            " "),
                        react_1.default.createElement("div", { className: "flex flex-col items-center gap-4 w-full" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Fill in the form below", size: "3xlarge", textColor: "text-primary", center: true, bold: true }),
                            react_1.default.createElement("div", { className: "flex flex-col gap-4 w-full" },
                                react_1.default.createElement(doshx_controls_web_1.AddressSearchControl, { label: "Physical Address/ Unit Number/ Building Name", borderColor: "border-[#EEEEEE]", value: address, errorText: addressErrorMessage, errorTextColor: "text-red-500", onSelectionChange: function (v) {
                                        setAddress(v);
                                    } }),
                                react_1.default.createElement(doshx_controls_web_1.DatePickerControl, { label: "Date Of Birth", borderColor: "border-[#EEEEEE]", inputFormat: "DD/MM/YYYY", errorTextColor: "text-red-500", errorText: dateOfBirthErrorMessage, value: dateOfBirth, onChange: function (v) {
                                        setDateOfBirth(v);
                                    } }),
                                react_1.default.createElement("div", { className: "flex flex-col gap-1" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Receive trusted health advice, the latest news and promotions?", size: "medium", textColor: "text-primary" }),
                                    react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "SMS", uncheckedColor: "text-primary", value: smsMethod, onChange: function (v) {
                                            manageComMethod("SMS", v);
                                        } }),
                                    react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "EMAIL", uncheckedColor: "text-primary", value: emailMethod, onChange: function (v) {
                                            manageComMethod("EMAIL", v);
                                        } }),
                                    react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "WHATSAPP", uncheckedColor: "text-primary", value: whatsAppMethod, onChange: function (v) {
                                            manageComMethod("WHATSAPP", v);
                                        } }))))))),
                react_1.default.createElement("div", { className: "flex flex-col gap-4 pt-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Submit", loading: isLoading, backgroundColor: "bg-primary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (agreesToTerms) {
                                    setAgreesMessage("");
                                    loyaltySignUp();
                                }
                                else {
                                    setAgreesMessage("Please agree to the Choice Card terms and conditions");
                                }
                                return [2 /*return*/];
                            });
                        }); } }),
                    react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "I have read and understood the Terms and Conditions.", uncheckedColor: "text-primary", textColor: "text-[#B1B1B1]", errorText: agreesMessage, value: agreesToTerms, onChange: function (v) {
                            setAgreesToTerms(v);
                        } })))) : (react_1.default.createElement("div", { className: "" },
                react_1.default.createElement("div", { className: "flex flex-col " },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Terms and conditions", size: "small", textColor: "text-success", center: true, uppercase: true }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Choice Card terms and conditions", size: "3xlarge", textColor: "text-primary", center: true })),
                react_1.default.createElement(react_markdown_1.ReactMarkdown, { className: "flex flex-col gap-4" }, termsData.userTerms),
                react_1.default.createElement("div", { className: "flex flex-col gap-4 pt-10 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "APPLY NOW", backgroundColor: "bg-primary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setIHaveReadTerms(true);
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                                return [2 /*return*/];
                            });
                        }); } }))))))));
};
exports.ChoiceCardApplicationPage = ChoiceCardApplicationPage;
